(() => {
  const mq = window.matchMedia('(max-width: 749px)');

  function setBlockState(block, open) {
    const button = block.querySelector('.footer-block__accordion-button');
    const content = block.querySelector('.footer-block__accordion-content');
    if (!button || !content) return;

    block.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    content.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function syncFooter() {
    document.querySelectorAll('.footer-block--mobile-accordion').forEach((block) => {
      if (mq.matches) {
        if (block.dataset.mobileAccordionReady !== 'true') {
          setBlockState(block, false);
          block.dataset.mobileAccordionReady = 'true';
        }
      } else {
        setBlockState(block, true);
        delete block.dataset.mobileAccordionReady;
      }
    });
  }

  function initFooterAccordion() {
    document.querySelectorAll('.footer-block--mobile-accordion').forEach((block) => {
      const button = block.querySelector('.footer-block__accordion-button');
      if (!button || button.dataset.footerAccordionBound === 'true') return;

      button.dataset.footerAccordionBound = 'true';
      button.addEventListener('click', () => {
        if (!mq.matches) return;
        setBlockState(block, !block.classList.contains('is-open'));
      });
    });

    syncFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion, { once: true });
  } else {
    initFooterAccordion();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', syncFooter);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(syncFooter);
  }

  document.addEventListener('shopify:section:load', initFooterAccordion);
})();
